import React, { useEffect } from "react";
import useNavigateNewPerson from "./useNavigateNewPerson";
import { usePermissionValidator } from "../api/UserPermissionValidators";
import LoadingSpinner from "../shared-components/LoadingSpinner";

type Props = {};

const NewReport = (props: Props) => {
  const { navigateCreatePerson } = useNavigateNewPerson();
  const { canAddReport } = usePermissionValidator();

  useEffect(() => {
    if (!canAddReport) {
      return;
    }
    navigateCreatePerson();
  }, [canAddReport, navigateCreatePerson]);

  return (
    <div>
      <LoadingSpinner />
    </div>
  );
};

export default NewReport;
